<template lang='pug'>
  .integrations
    website-spacing
      v-row(justify='center')
        v-col
          .display-2.pa-4.grey--text.text--darken-3.text-center Integrations
          .headline.pa-4.grey--text.text--darken-2.text-center If you use it, we probably integrate with it.
      v-row
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/github.png' max-width='150' lazy-src='../assets/integrations/github.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/slack.png' max-width='150' lazy-src='../assets/integrations/slack.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/hipchat.png' max-width='150' lazy-src='../assets/integrations/hipchat.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/heroku.png' max-width='150' lazy-src='../assets/integrations/heroku.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/circleci.png' max-width='150' lazy-src='../assets/integrations/circleci.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/jenkins.png' max-width='150' lazy-src='../assets/integrations/jenkins.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/codeship.png' max-width='150' lazy-src='../assets/integrations/codeship.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/travis.png' max-width='150' lazy-src='../assets/integrations/travis.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/pagerduty.png' max-width='150' lazy-src='../assets/integrations/pagerduty.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/ifttt.png' max-width='150' lazy-src='../assets/integrations/ifttt.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/zapier.png' max-width='150' lazy-src='../assets/integrations/zapier.png')
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card.integration-card.ma-2
            v-row(justify='center' align='center').fill-height
              v-img(src='../assets/integrations/webhook.png' max-width='150' lazy-src='../assets/integrations/webhook.png')
      v-row(justify='center')
        .pa-4.grey--text.text--darken-2.text-center *And if we don’t integrate yet, we’re always happy to integrate with the tools you use.
</template>

<script>

import WebsiteSpacing from './WebsiteSpacing';
export default {
  name: 'Integrations',
  components: {WebsiteSpacing},
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  data() {
    return {
      integrations: [] // went away from a loop so webpack can find the images
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .integrations {
    background: linear-gradient(180deg, #ffffff, #ECEFF1);
  }

  .integration-card {
    height: 100%;
  }


  .whitespace {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }
</style>
